import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, lastValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Result, Root, Filter } from '../interfaces/Ordenes';
import { RootOrden } from '../interfaces/OrdenesInstalaciones.interface';

@Injectable({
  providedIn: 'root'
})
export class ReportOrderService implements OnInit {
  private http = inject(HttpClient);
  url = environment.API_URL;
  data: Filter[] = []
  constructor() { }

  ngOnInit(): void {
    // console.log("esta es una prueba")
  }

  getOrder():  Promise<RootOrden> {
    let urlGet = `${this.url}/api/gsoft/installations/orders/?order_confirmation=true&status=41`;
    return lastValueFrom(this.http.get<RootOrden>(urlGet))
  }
  getOrderParams(body: Filter): Promise<RootOrden> {
    let urlGet = `${this.url}/api/gsoft/installations/orders/?search=${body.search}&page=${body.page}&since=${body.since}&until=${body.until}&confirmation=${body.confirmation}&order_confirmation=true&status=41`;
    const gt = this.http.get<RootOrden>(urlGet);
    return lastValueFrom(gt)
  }

  postConfirmOrder(order:object){
    // console.log(order, 'este  es la orden')
    const post = this.http.post(`${this.url}/api/gsoft/installations/calendar/confirm/`, order);
    return lastValueFrom(post);
  }

  confirmOrder(id:number,body:object){
    // console.log(order, 'este  es la orden')
    const post = this.http.patch(`${this.url}/api/gsoft/installations/orders/${id}/`, body);
    return lastValueFrom(post);
  }

}
